export const AMS_SYNC_LOGS = 'AMS Sync Logs';
export const TAB_2 = 'Tab 2';
export const TAB_3 = 'Tab 3';
export const TAB_4 = 'Tab 4';
